import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const SpeedConverterGuidePage = () => <DataDrivenGuidePage slug="guide-speed-calculator" />;

export default SpeedConverterGuidePage;
